import * as types from "../types/systemSettings"

const initialState = {
  domain: "",
  subdomain: "",
  contractId: "",
  kioskMode: false,
  kioskNumber: "",
  autoConfirmOrders: false,
  autoCheckout: false,
  enableInstantQrCode: false,
  maximumFoodOrderCountPerDay: null,
  promotions: [],
  topupAmounts: [],
  locationOptions: [],
  defaultReferralPercentage: null,
  billplzTransactionLimitation: null,
  closeOrderingTime: null,
  lunchCloseOrderTime: null,
  dinnerCloseOrderTime: null,
  kitchenAddress: "",
  kitchenMap: "",
  kitchenIframe: "",
  kitchenContact: "",
  kitchenEmail: "",
  kitchenTitle: "",
  kitchenLogo: "",
  systemIsActivated: null,
  primaryPrinters: [],
  lalamoveLunchDeliveryTime: [],
  lalamoveDinnerDeliveryTime: [],
  workingDaysOfWeek: [],
  kitchenLocation: { coordinates: [] },
  workingDaysOfWeekWithHour: [],
  websiteFeatures: null,
  panelFeatures: null,
  cashTypes: [],
  instantOrderSettings: {
    lastCall: null,
    requiredDeliveryTime: null,
    lunchSchedules: [],
    dinnerSchedules: []
  }
}

const systemSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SYSTEM_SETTINGS:
      return { ...state, ...action.data }
    case types.FETCH_SYSTEM_LOCATIONS:
      return {
        ...state,
        locationOptions: [...action.locationOptions]
      }
    case types.TOGGLE_TEMPORARY_OFF:
      return {
        ...state,
        temporaryOff: !state.temporaryOff
      }
    case types.TOGGLE_INSTANT_QR_CODE:
      return {
        ...state,
        enableInstantQrCode: !state.enableInstantQrCode
      }
    case types.UPDATE_SYSTEM_SETTINGS:
      return {
        ...state,
        ...action.newSystemSettings
      }
    case types.TOGGLE_AUTO_CONFIRM:
      return {
        ...state,
        autoConfirmOrders: !state.autoConfirmOrders
      }
    case types.SET_SYSTEM_SUBDOMAIN:
      return {
        ...state,
        domain: action.domain,
        subdomain: action.subdomain
      }
    case types.TOGGLE_KIOSK_MODE:
      return {
        ...state,
        kioskMode: !state.kioskMode
      }
    case types.SET_KIOSK_NUMBER:
      return {
        ...state,
        kioskNumber: action.kioskNumber
      }
    default:
      return state
  }
}

export default systemSettingsReducer